import { render, staticRenderFns } from "./aliHtml.vue?vue&type=template&id=c10bf23e&"
import script from "./aliHtml.vue?vue&type=script&lang=js&"
export * from "./aliHtml.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports